import { useEffect, useState } from "react";
import { fetchExportUnitExclusions } from "../services/exportUnitExclusions.api";
import { mapExportUnitExclusionRows } from "../utils/exportUnitExclusions.helpers";

export function useExportUnitExclusions() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const ac = new AbortController();

    (async () => {
      try {
        setLoading(true);
        const list = await fetchExportUnitExclusions(ac.signal);
        setRows(mapExportUnitExclusionRows(list));
      } catch (e) {
        console.error("useExportUnitExclusions:init", e);
        setRows([]);
      } finally {
        setLoading(false);
      }
    })();

    return () => ac.abort();
  }, []);

  return { rows, loading, refreshing: false };
}

export default useExportUnitExclusions;
